




































































import name from '@/validators/rules/name';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import { sameAs, required } from 'vuelidate/lib/validators';

@Component({
  name: 'PhoneForm',
  validations: {
    name: {
      required,
      name,
    },
    isAgreeWithTermOfUseOfTheService: {
      sameAs: sameAs(
        () => true
      )
    },
  }
})
export default class PhoneForm extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  private currentName!: string;

  @Prop({
    type: Boolean,
    required: true,
  })
  private hasError!: boolean;

  private name: string = this.currentName;
  private isAgreeWithTermOfUseOfTheService: boolean = false;

  @Watch('name')
  private onNameChanged(name: string) {
    this.$emit('update:currentName', name);
  }

  @Watch('isAgreeWithTermOfUseOfTheService')
  private onIsAgreeWithTermOfUseOfTheServiceChanged(isAgreeWithTermOfUseOfTheService: boolean) {
    this.$emit('changeAgree', isAgreeWithTermOfUseOfTheService);
  }
}
